import {Backbone} from 'Vertebrae';
import {Program} from '../model/program';

export const Programs = Backbone.Collection.extend({
    _name: 'Programs',
    model: Program,
    url: '/registration/programs/get.json',
});
